import { render, staticRenderFns } from "./loadingGif.vue?vue&type=template&id=70d878bc&"
import script from "./loadingGif.vue?vue&type=script&lang=js&"
export * from "./loadingGif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "loadingGif.vue"
export default component.exports